export const STREAM_CONTENT_VISIBLE_CHANGE_SUCCESS =
    "STREAM_CONTENT_VISIBLE_CHANGE_SUCCESS";
export const SET_VIDEO_CALL_DETAILS_SUCCESS = "SET_VIDEO_CALL_DETAILS_SUCCESS";
